import styled from '@emotion/styled';
import { theme } from '../../../theme';
import { InternalTextInput } from '../text-input';
export const StyledInputStepper = styled.div `
	display: flex;
	margin-bottom: 1rem;
	flex-direction: ${({ layout }) => layout === 'horizontal' ? 'row' : 'column'};
	${({ layout }) => layout === 'horizontal'
    ? 'justify-content: space-between'
    : { flexWrap: 'wrap', alignContent: 'center' }};
`;
export const LabelSupportingTextWrapper = styled.div `
	display: flex;
	flex-direction: column;
	margin: ${({ supportingText, layout }) => supportingText || layout === 'vertical' ? '0 8px 8px 0' : '0'};
	${({ supportingText }) => supportingText
    ? ''
    : { display: 'flex', alignItems: 'center', maxHeight: '45px' }};
	${({ supportingText, layout }) => !supportingText && layout === 'horizontal' ? 'align-self: center' : ''}
`;
export const StyledLabel = styled.label `
	${theme.typography.IM90};
	color: ${theme.colors.typography.label};
	line-height: 17.5px;
	margin: 0;
`;
export const StyledSupportingLabel = styled.label `
	${theme.typography.IR90};
	color: ${theme.colors.typography.body};
	line-height: 21px;
	margin: 4px 0 0;
`;
export const InputStepperWrapper = styled.section `
	display: flex;
	flex-direction: row;
`;
export const StyledMinusButton = styled.span `
	margin-right: 8px;
`;
export const StyledPlusButton = styled.span `
	margin-left: 8px;
`;
export const FieldErrorMessageWrapper = styled.div `
	display: flex;
	flex-direction: column;
	width: ${({ inputWidth }) => inputWidth};
`;
export const StyledInternalTextInput = styled(InternalTextInput) `
	// This removes the default increment/decrement arrows for a number input
	// https://stackoverflow.com/a/71297126
	::-webkit-outer-spin-button,
	::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
		-moz-appearance: textfield !important;
	}
	width: 100%;

	// this removes the clock icon for a time input
	::-webkit-calendar-picker-indicator {
		display: none;
	}
`;
//# sourceMappingURL=InputStepper.styled.js.map